export default class ExceptionsService {
  constructor($translate) {
    this.$translate = $translate;
  }

  getErrorMessage(errorCode) {
    const _ = this.$translate.instant;
    return {
      'PR0001': _('Ya existe un punto de ventas con este número'),
      'PR0002': _('Este punto de ventas ya está enlazado a este colector'),
      'PR0003': _('Este punto de ventas no está enlazado a este colector'),
      'PR0006': _('Este punto de venta está siendo observado por un colector.'),
      'IA0001': _('Metodo de autenticación no permitido'),
      'IA0002': _('La cuenta ya esta enlazada con el metodo de autenticación seleccionado'),
      'IA0003': _('Las credenciales son incorrectas, intente nuevamente'),
      'IA0004': _('La direccion de correo electronico no ha sido agregado'),
      'IA0005': _('Este email ha sido registrado con otro usuario anteriormente'),
      'IA0006': _('La cuenta ha sido enlazada con Facebook anteriormente'),
      'IA0007': _('La cuenta ha sido enlazada con Google anteriormente'),
      'IA0008': _('La cuenta ha sido enlazada con Twitter anteriomente'),
      'IA0009': _('El usuario ha sido activado previamente'),
      'IA0010': _('El usuario ha sido desactivado previamente'),
      'IA0011': _('Una cuenta con este nombre ya existe en el sistema, utilize un nombre diferente'),
      'IA0012': _('No tiene invitaciones pendientes'),
      'IA0013': _('El token de recuperación es inválido'),
      'IA0014': _('Su usuario ya posee una contraseña, puede cambiarla si gusta'),
      'IA0015': _('El token de verificación de correo es inválido'),
      'IA0016': _('Debe iniciar sesión para realizar esta acción'),
      'IA0017': _('El usuario que intenta agregar ya es parte de esta cuenta'),
      'IA0018': _('Imposible activar este usuario, ha sido activado previamente'),
      'IA0019': _('Imposible desactivar este usuario, ha sido desactivado previamente'),
      'IA0020': _('Imposible eliminar este usuario, ha sido eliminado previamente'),
      'IA0021': _('Este usuario len ha sido otorgados derechos administrativos previamente'),
      'IA0022': _('Este usuario ya no posee derechos administrativos'),
      'IA0023': _('Toda cuenta debe de tener al menos un usuario administrador'),
      'IA0024': _('Este usuario ya cuenta con el permiso que intenta asignarle'),
      'IA0025': _('Este permiso no ha sido otorgado al usuario, imposible revocar'),
      'IA0026': _('Para poder proceder debe crear una contraseña'),

      'PAYMENT_PENDING': _('Existe un pago pendiente, imposible proceder.')
    }[errorCode] || _('Un error ha ocurrido, y ha sido reportado');
  }
}

ExceptionsService.$inject = ['$translate'];



// WEBPACK FOOTER //
// ./src/app/services/exceptions.service.js